import { render } from "./EmployeeAnnouncements.vue?vue&type=template&id=22e32bf6&scoped=true"
import script from "./EmployeeAnnouncements.vue?vue&type=script&lang=js"
export * from "./EmployeeAnnouncements.vue?vue&type=script&lang=js"

import "./EmployeeAnnouncements.vue?vue&type=style&index=0&id=22e32bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e32bf6"]])

export default __exports__